<template>
    <div class="form-group">
        <label v-if="label" :for="id">{{ label }}<span class="text-info" style="font-size: 12px">{{ span }}</span></label>
        <input :id="id" :type="type" :value="modelValue" v-bind="{ ...$attrs, class: null }"
            @input="$emit('update:modelValue', $event.target.value)" :class="class">
        <div v-if="error" style="color:#dc3545; font-size:80%">{{ error }}</div>
    </div>
</template>
  
<script>
import { v4 as uuid } from 'uuid'

export default {
    name: 'Input',
    inheritAttrs: false,
    props: {
        id: {
            type: String,
            default() {
                return `input-text-${uuid()}`
            },
        },
        type: {
            type: String,
            default: 'text',
        },
        error: {
            type: String,
            default: null
        },
        label: {
            type: String,
            default: ''
        },
        span: {
            type: String,
            default: ''
        },
        modelValue: String,
        class: {
            type: String,
            default: 'form-control',
        },
    },
    emits: ['update:modelValue'],
    methods: {
        focus() {
            this.$refs.input.focus()
        },
        select() {
            this.$refs.input.select()
        },
        setSelectionRange(start, end) {
            this.$refs.input.setSelectionRange(start, end)
        },
    },
}
</script>